import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { ErrorBoundary } from './components/ErrorBoundary.tsx'
import { registerServiceWorker } from './lib/registerServiceWorker.ts'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
)

// Boot-resilience precache (production only). Registered after load so it never
// competes with the initial render, and fail-soft so it can't break boot.
if (import.meta.env.PROD) {
  window.addEventListener('load', () => registerServiceWorker())
}
